import { api } from "@/builders/axios";
import { StaffPerformanceList } from "@/builders/types/action-points";
import { FilterParams } from "@/builders/types/filter-params";

export const staff_performance = function (
  params?: FilterParams<{
    organization_id?: number;
  }>
) {
  return api
    .get<StaffPerformanceList>("action-points/staff-performance", { params })
    .then(({ data }) => data);
};

